<template>
  <el-form v-model="formData" :disabled="disabled">
    <el-row :gutter="20">
      <el-col :sm="{ span: 24 }" :md="{ span: 8 }" :lg="{ span: 6 }">
        <el-form-item label="预约平台">
          <el-select
            v-model="formData.f1"
            placeholder="请选择预约平台"
            style="width: 100%"
          >
            <el-option label="A" value="A" />
            <el-option label="B" value="B" />
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :sm="{ span: 24 }" :md="{ span: 8 }" :lg="{ span: 6 }">
        <el-form-item label="是否返程">
          <el-select
            v-model="formData.f2"
            placeholder="请选择是否返程"
            style="width: 100%"
          >
            <el-option label="A" value="A" />
            <el-option label="B" value="B" />
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :sm="{ span: 24 }" :md="{ span: 8 }" :lg="{ span: 6 }">
        <el-form-item label="特定收货">
          <el-select
            v-model="formData.f3"
            placeholder="请选择特定收货"
            style="width: 100%"
          >
            <el-option label="A" value="A" />
            <el-option label="B" value="B" />
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :sm="{ span: 24 }" :md="{ span: 8 }" :lg="{ span: 6 }">
        <el-form-item label="班车类型">
          <el-select
            v-model="formData.f4"
            placeholder="请选择班车类型"
            style="width: 100%"
          >
            <el-option label="A" value="A" />
            <el-option label="B" value="B" />
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>
<script>
export default {
  props: {
    disabled: Boolean,
  },
  data() {
    return {
      formData: {},
    }
  },
}
</script>
